import type { PixelEvent } from '@/events';
import type { DispatcherService } from '@/services/dispatcher/types';

export class DispatcherSubscriber {
  private readonly dispatcher: DispatcherService;

  private readonly onEvent: (event: PixelEvent) => void;

  private unsubscribe: (() => void) | null = null;

  constructor(
    dispatcher: DispatcherService,
    onEvent: (event: PixelEvent) => void
  ) {
    this.dispatcher = dispatcher;
    this.onEvent = onEvent;
  }

  subscribe(): void {
    if (this.unsubscribe) return;
    this.unsubscribe = this.dispatcher.subscribe(event => this.onEvent(event));
  }

  unsubscribeAll(): void {
    this.unsubscribe?.();
    this.unsubscribe = null;
  }

  isSubscribed(): boolean {
    return this.unsubscribe !== null;
  }
}
